
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';

@Component
export default class TakeoverCastMember extends Vue {
  @Prop(Object) readonly doc!: ISanityDocuments[SanityDocumentSchema.PERSON];
  @Prop(String) readonly role?: String;
  @Prop(Boolean) readonly loading!: boolean;

  roleType = SanityDocumentSchema.ROLE;

  get name() {
    return this.doc?.name;
  }

  get imageUrl() {
    if (!this.doc?.image) {
      return '';
    }

    const image = this.doc?.image;

    const imageSource = {
      asset: image.asset,
      crop: image.crop,
      hotspot: image.hotspot,
    };

    return this.$sanityImage.urlFor(imageSource).url();
  }
}
